import { resolveBoolFlag } from "../appConfig/resolveBoolFlag";
import { APP_CONFIG } from "../../constant/common";
import { ENDPOINT } from "../../constant/environment";

export const XENIA_CHAT_URL = `${ENDPOINT}/app/v1/xenia/chat`;

export function isSseTransportEnabled(appConfig: unknown): boolean {
  if (import.meta.env.MODE !== "production") {
    try {
      const override = window.localStorage.getItem("_zenvoya_sse_transport");
      if (override === "1") return true;
      if (override === "0") return false;
    } catch {}
  }
  return resolveBoolFlag(appConfig as any, APP_CONFIG.XENIA_ENABLED);
}

export { isXeniaPortedRequestType } from "./sseRequestTypes";
